import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from './LinkedHashSet.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from './collectionJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import {
  convertToListIfNotCollection2y7m25iq802o0 as convertToListIfNotCollection,
  addAll1k27qatfgp3k5 as addAll,
} from './MutableCollections.mjs';
import { toSet2orjxp16sotqu as toSet } from './_Collections.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { collectionSizeOrNull1v5nsm81on7r9 as collectionSizeOrNull } from './Iterables.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function plus(_this__u8e3s4, element) {
  var result = LinkedHashSet().d2(mapCapacity(_this__u8e3s4.q2() + 1 | 0));
  result.u2(_this__u8e3s4);
  result.i2(element);
  return result;
}
function minus(_this__u8e3s4, element) {
  var result = LinkedHashSet().d2(mapCapacity(_this__u8e3s4.q2()));
  var removed = false;
  // Inline function 'kotlin.collections.filterTo' call
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var element_0 = _iterator__ex2g4s.r1();
    var tmp;
    if (!removed && equals(element_0, element)) {
      removed = true;
      tmp = false;
    } else {
      tmp = true;
    }
    if (tmp) {
      result.i2(element_0);
    }
  }
  return result;
}
function minus_0(_this__u8e3s4, elements) {
  var other = convertToListIfNotCollection(elements);
  if (other.n1())
    return toSet(_this__u8e3s4);
  if (isInterface(other, KtSet())) {
    // Inline function 'kotlin.collections.filterNotTo' call
    var destination = LinkedHashSet().s2();
    var _iterator__ex2g4s = _this__u8e3s4.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!other.t2(element)) {
        destination.i2(element);
      }
    }
    return destination;
  }
  var result = LinkedHashSet().c3(_this__u8e3s4);
  result.w3(other);
  return result;
}
function plus_0(_this__u8e3s4, elements) {
  var tmp0_safe_receiver = collectionSizeOrNull(elements);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = _this__u8e3s4.q2() + tmp0_safe_receiver | 0;
  }
  var tmp1_elvis_lhs = tmp;
  var result = LinkedHashSet().d2(mapCapacity(tmp1_elvis_lhs == null ? imul(_this__u8e3s4.q2(), 2) : tmp1_elvis_lhs));
  result.u2(_this__u8e3s4);
  addAll(result, elements);
  return result;
}
//region block: exports
export {
  minus_0 as minus165a8u1e0x1lu,
  minus as minus27abgkurcn6u0,
  plus_0 as plus1ogy4liedzq5j,
  plus as plus18eogev54fmsa,
};
//endregion

//# sourceMappingURL=_Sets.mjs.map
